export default __webpack_public_path__ + "static/media/firstcry.8c3c79e3.png";